// For documentation, see https://github.com/greena13/react-simple-file-input
import React from 'react';
import { doFileUpload, hasError, isUploadPending } from './fileupload';
import { connect } from 'react-redux';
import FileInput from '../FileInput/FileInput';
import { toastr } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { actions as toastrActions } from 'react-redux-toastr';
import { loadAbnormalityFiles } from '../../modules/abnormalities/duck';

const toastrOptionsWarning = {
    timeOut: 10000,
};

const toastrOptionsInfo = {
    timeOut: 0,
    icon: <i style={{ margin: 20 }} className="fa fa-spinner fa-pulse fa-2x fa-fw" />,
};

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amountUploaded: 0,
            filesize: 0,
            abortUpload: false,
            uploadPending: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!this.props.isUploadPending && nextProps.isUploadPending) {
            this.props.toastr.add({
                id: 'pendingUpload',
                type: 'info',
                title: 'Uploading file(s)',
                attention: true,
                position: 'top-right', // do not remove, there is a bug in v.6
                options: toastrOptionsInfo,
            });
        }
        if (this.props.isUploadPending && !nextProps.isUploadPending) {
            this.props.toastr.remove('pendingUpload');
            if (!nextProps.hasError) {
                toastr.success('File(s) uploaded');
            }
        }
    }

    handleFileUpload = files => {
        if (Array.from(files).length > 0) {
            const formData = new FormData();
            Array.from(files).map(file => formData.append('file', file));
            this.props
                .doFileUpload({
                    formData: formData,
                    url: this.props.url,
                })
                .then(() => {
                    setTimeout(() => {
                        this.props.loadAttachments(this.props.abnormalityId);
                    }, 500);
                });
        }
    };

    fileHasDisallowedFiletype = file => {
        const { allowedFileTypes } = this.props;
        console.log(
            'Disallowed file type?',
            file.type === '' || allowedFileTypes.indexOf(file.type) === -1
        );
        return file.type === '' || allowedFileTypes.indexOf(file.type) === -1;
    };

    showInvalidFileTypeMessage = file => {
        const extension = file.name.split('.').pop();
        toastr.warning(`".${extension}" files cannot be uploaded...`, toastrOptionsWarning);
    };

    render() {
        const { allowedFileTypes, isUploadPending } = this.props;

        return (
            <div>
                <label>
                    <FileInput
                        style={{ display: 'none' }}
                        readAs="binary"
                        multiple
                        accept={allowedFileTypes}
                        onChange={this.handleFileUpload}
                        cancelIf={this.fileHasDisallowedFiletype}
                        onCancel={this.showInvalidFileTypeMessage}
                    />
                    <span
                        className={`btn btn-success ${isUploadPending ? 'disabled' : ''}`}
                        style={{ marginTop: 10, marginRight: 5 }}
                    >
                        Upload file(s)
                    </span>
                </label>
            </div>
        );
    }
}

export default connect(
    state => ({
        fileUpload: state.fileUpload,
        isUploadPending: isUploadPending(state),
        hasError: hasError(state),
    }),
    dispatch => ({
        doFileUpload: bindActionCreators(doFileUpload, dispatch),
        toastr: bindActionCreators(toastrActions, dispatch),
        loadAttachments: bindActionCreators(loadAbnormalityFiles, dispatch),
    })
)(FileUpload);
